import type { TransacaoPagarmeModel } from "../../../services/extratoPagarmeFornecedor"

export type { TransacaoPagarmeModel }

export type ExtratoPagarmeFornecedorModel = {
    dataInicio: string
    dataFim: string
    transacoes: TransacaoPagarmeModel[]
    saldo: string
}

const hoje = () => {
    const d = new Date()
    return d.toISOString().slice(0, 10)
}

export const ExtratoPagarmeFornecedorInicial: ExtratoPagarmeFornecedorModel = {
    dataInicio: hoje(),
    dataFim: hoje(),
    transacoes: [],
    saldo: "",
}
